import { isSameDay } from 'utils/date'
import { DayCellWrapper } from './day-cell.styles'

interface IProps {
  day: Date | null
  range: { start: Date | null; end: Date | null }
  onDayClick: (
    day: Date,
    range: { start: Date | null; end: Date | null },
    setRange: (newRange: { start: Date | null; end: Date | null }) => void,
    setIsOpen: (isOpen: boolean) => void
  ) => void
  setRange: (newRange: { start: Date | null; end: Date | null }) => void
  setIsOpen: (isOpen: boolean) => void
}

export interface DayCellWrapperProps {
  isStart: boolean
  isEnd: boolean
  inRange: boolean | null
  isPending: boolean | null
  isSingleDayRange: boolean
}

const DayCell = ({ day, range, onDayClick, setRange, setIsOpen }: IProps) => {
  if (!day) {
    // Empty cell for padding
    return <div className="h-10 w-full"></div>
  }

  // Check selection state
  const hasFullRange = range.start && range.end
  const hasPendingStart = range.start && !range.end

  let startDay = null
  let endDay = null

  if (hasFullRange) {
    startDay =
      !!range?.start && !!range.end
        ? range.start < range.end
          ? range.start
          : range.end
        : new Date()
    endDay =
      !!range?.start && !!range.end
        ? range.start < range.end
          ? range.end
          : range.start
        : new Date()
  }

  const isStart = isSameDay(day, startDay || new Date())
  const isEnd = isSameDay(day, endDay || new Date())
  const inRange =
    hasFullRange &&
    day > (startDay || new Date()) &&
    day < (endDay || new Date())
  const isPending = hasPendingStart && isSameDay(day, range.start ?? new Date())

  // Handle the special case where the range is a single day
  const isSingleDayRange = isStart && isEnd

  return (
    <DayCellWrapper
      isStart={isStart}
      isEnd={isEnd}
      inRange={inRange}
      isPending={isPending}
      isSingleDayRange={isSingleDayRange}
      onClick={() => onDayClick(day, range, setRange, setIsOpen)}
    >
      {day.getDate()}
    </DayCellWrapper>
  )
}

export default DayCell
